import { useEffect, useState } from "react";
import { get } from "@/lib/api";
import { ClipboardCheck, Inbox, Users, Eye, CalendarClock, ShieldAlert } from "lucide-react";

const Q = [
  { key: "attention_count", q: "What needs my judgement today?", icon: ClipboardCheck },
  { key: "awaiting_activation", q: "Which volunteers are ready to activate?", icon: Users },
  { key: "sources_watch", q: "Which source or policy has changed?", icon: Eye },
  { key: "reviews_due", q: "Which guidance is due for review?", icon: CalendarClock },
  { key: "open_requests", q: "Which room requests need a response?", icon: Inbox },
];

export function TodayPanel({ onNavigate }) {
  const [t, setT] = useState(null);
  useEffect(() => { get("/desk/today").then(setT); }, []);
  if (!t) return null;
  return (
    <div className="space-y-6" data-testid="today-panel">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {Q.map((item) => (
          <div key={item.key} className="rounded-2xl border border-stone-200 bg-white p-5" data-testid={`today-${item.key}`}>
            <div className="flex items-center justify-between">
              <item.icon className="h-4 w-4 text-mill-moss" />
              <span className="font-display text-3xl font-bold text-mill-ink">{t[item.key]}</span>
            </div>
            <p className="mt-2 text-sm text-mill-muted">{item.q}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid="today-restricted">
          <div className="flex items-center gap-2"><ShieldAlert className="h-4 w-4 text-[#B45309]" /><h3 className="font-display text-base font-semibold text-mill-ink">Restricted cases</h3></div>
          <p className="mt-1 text-xs text-mill-muted">Responsible role: {t.restricted.responsible_role}</p>
          <div className="mt-3 flex flex-wrap gap-2 text-xs">
            {Object.entries(t.restricted.counts).map(([k, v]) => (
              <span key={k} className="rounded-full bg-mill-alt px-2.5 py-1 font-medium text-mill-ink" data-testid={`restricted-${k}`}>{v} {k.replace(/_/g, " ")}</span>
            ))}
            {t.restricted.total === 0 && <span className="text-mill-muted">No open cases.</span>}
          </div>
          <p className="mt-3 rounded-lg bg-[#FEF2F2] px-3 py-2 text-[11px] text-[#991B1B]">{t.restricted.boundary}</p>
        </div>

        <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid="today-upcoming">
          <div className="flex items-center gap-2"><CalendarClock className="h-4 w-4 text-mill-moss" /><h3 className="font-display text-base font-semibold text-mill-ink">Upcoming</h3></div>
          <ul className="mt-3 space-y-2 text-sm">
            {t.upcoming.map((u) => (
              <li key={u.label} className="flex items-center justify-between">
                <span className="text-mill-ink">{u.label}</span>
                <span className="text-mill-muted">{u.date}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
